import React from 'react'

export default function({ text, color, size='md' }) {
  const sizeClass = `gds--pill--${size}`
  const colorClass = color
  return (
    <div className={`gds--pill ${colorClass} ${sizeClass}`}>
      {text}
    </div>
  )
}
